import React from "react";
import ReactDOM from "react-dom";
import AppWrapper from "./AppWrapper";
import { RecentImagesProvider } from "./components/SPA/hooks/recentimages";
import PriceListProvider from "./components/Providers/PriceListProvider";
import CalendarListPage from "./components/Desktop/CalendarList/CalendarListPage";
if (document.getElementById("root")) {
    ReactDOM.render(React.createElement(AppWrapper, null,
        React.createElement(PriceListProvider, null,
            React.createElement(RecentImagesProvider, null,
                React.createElement(CalendarListPage, null)))), document.getElementById("root"));
}
